import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";

import { title, List } from "utils";

import { Header } from "components";
import { Button } from "antd";

import { notificationActions } from "actions";

class HomePage extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>{title("Accueil")}</Helmet>
        <div className="home-page main-content">
          <Header title="Accueil" />

          <List cards={true} type="home" />
        </div>
      </Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    notifier: {
      subscribe: () => dispatch(notificationActions.subscribe()),
      send: (message, toUserId) => dispatch(notificationActions.send(message, toUserId)),
    },
  };
}

function mapStateToProps(state) {
  const { notifications } = state;
  return {
    notifications,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
